<a #topOfPage id="topOfPage"></a>
@if (isMobile) {
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
} @else {
  <prism-ui-page-content
    key-id="page-content"
    custom-max-width="480"
    >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </prism-ui-page-content>
}

<ng-template #contentTemplate>
  <div class="page-content" page-content>
    <prism-ui-heading
      font-size="lg"
      font-weight="regular"
      key-id="residence-title"
      is-uppercase="false"
      variant="default"
      >{{pageTitle}}
    </prism-ui-heading>

    <form [formGroup]="stateForm" (ngSubmit)="onSubmit()" class="form-inline">

      <prism-ui-container
        is-compact="false"
        key-id="residence-container"
        has-shadow="false"
        variant="default"
        has-no-border-radius="false"
        >

        <div class="row">
          <prism-ui-copy
            font-size="md"
            font-style="normal"
            font-weight="medium"
            key-id="residence-intro"
            line-height="medium"
            text-decoration="none"
            variant="default"
            >
            <span>{{intro}}</span>
          </prism-ui-copy>
        </div>
        <div class="dropDownContainer">
          @if (displayCountryList) {
            <div class="oneCell">
              <prism-ui-form-field
                [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'country')"
                key-id="applicantStateOfBirth"
                >
                <prism-ui-select
                  slot="input"
                  key-id="country"
                  has-placeholder="false"
                  [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'country')"
                  [options]="countryLabels"
                  [selectedValue]="getCountryLabel(stateForm.get('country')?.value)"
                  ngDefaultControl
                  [formGroup]="stateForm"
                  formControlName="country"
                  (selectEvent)="handleOptionSelectedCountry($event, 'country')"
                  >
                </prism-ui-select>
              </prism-ui-form-field>
            </div>
            @if (country.value === 'US') {
              <div class="oneCell">
                <prism-ui-form-field
                  [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'state')"
                  key-id="state"
                  >
                  <span slot="error">{{ stateElement?.error }}</span>
                  <prism-ui-select
                    slot="input"
                    key-id="state"
                    has-placeholder="true"
                    is-required="true"
                    [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'state')"
                    [options]="stateRegionListLabels"
                    [selectedValue]="getStateLabel(stateForm.get('state')?.value)"
                    ngDefaultControl
                    [formGroup]="stateForm"
                    formControlName="state"
                    (selectEvent)="handleOptionSelectedState($event, 'state')"
                    >
                  </prism-ui-select>
                </prism-ui-form-field>
              </div>
            }
          }
          @if (!displayCountryList) {
            <div class="oneCell">
              <prism-ui-form-field
                [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'state')"
                key-id="state"
                >
                <span slot="error">{{ stateElement?.error }}</span>
                <prism-ui-select
                  slot="input"
                  key-id="state"
                  has-placeholder="true"
                  is-required="true"
                  [isValid]="formControlUtilitiesService.isControlValid(stateForm, 'state')"
                  [options]="stateRegionNMListLabels"
                  [selectedValue]="getStateLabel(stateForm.get('state')?.value)"
                  ngDefaultControl
                  [formGroup]="stateForm"
                  formControlName="state"
                  (selectEvent)="handleOptionSelectedState($event, 'state')"
                  >
                </prism-ui-select>
              </prism-ui-form-field>
            </div>
          }
        </div>
      </prism-ui-container>
      <div class="row continueCancelButtonPadding">
        <app-continue-cancel (cancelEmitter)="onCancel()"></app-continue-cancel>
      </div>
    </form>
  </div>
</ng-template>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{modalContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="cancel-modal"
      >
      {{modalContentBody}}
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-cancel-modal')"
        >Cancel</prism-ui-button>
        <prism-ui-button class="leftPaddingSmall"
          button-width="full"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="leaveAnyway()"
        >Leave Anyway</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>

  <prism-ui-modal key-id="error-modal" has-dark-overlay="true">
    <prism-ui-heading
      slot="modal-header"
      key-id="error-modal"
      font-size="sm"
      font-weight="strong"
      >{{errorModalContentHeading}}</prism-ui-heading
      >
      <prism-ui-copy
        slot="modal-body"
        key-id="error-modal"
        >
        {{errorModalContentBody}}
      </prism-ui-copy>
      <div slot="modal-footer">
        <div class="modalButtonStyling">
          <prism-ui-button
            button-width="full"
            key-id="cancel-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            (click)="onCancelModal('prism-ui-modal-error-modal')"
          >Cancel</prism-ui-button>
          <prism-ui-button class="leftPaddingSmall"
            button-width="full"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="leaveAnyway()"
          >Leave Anyway</prism-ui-button>
        </div>
      </div>
    </prism-ui-modal>